module.exports = __webpack_public_path__ + "static/media/check_icon.bcd6dc4f.svg";